import React from 'react';
import { connect } from "react-redux";
import { withStyles, Dialog, Typography, DialogActions, Button } from "@material-ui/core";

const styles = theme => ({
    root: {
        width: '90%',
        height: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    dialogPaper: {
        minHeight: '20vh',
        maxHeight: '70vh',
    },
    title: {
        marginTop: theme.spacing(2),
        textAlign: 'center'
    },
    text: {
        paddingTop: theme.spacing(4),
        textAlign: 'center',
        padding: theme.spacing(3)
    },
    countDownText: {
        textAlign: 'center',
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "80%",
        marginTop: theme.spacing(5),
        margin: theme.spacing(3)
    },
});

const UserIdleModal = props => {
    const { classes, translations, open, handleLogout, state } = props;

    return (
        <div className={classes.root}>
            <Dialog classes={{ paper: classes.dialogPaper }}  aria-labelledby="customized-dialog-title" open={open} fullWidth={true}
                maxWidth={'sm'} >
               <Typography variant='h5' className={classes.text}>{translations['idle_warning'] || `Session has been idle over its time limit. It will be disconnected in ${state?.limit} seconds. Click anywhere to continue session`}</Typography>
                {state?.autoLogoutValue < state?.limit ? <Typography variant='h4' className={classes.countDownText}>{state?.autoLogoutValue} {translations['seconds_left'] || `seconds left`}</Typography> : null}
                <DialogActions>
                    < Button
                        className={classes.submit}
                        variant="contained"
                        type="submit"
                    >
                        {translations['stay_signed'] || 'Stay signed in'}
                    </Button>
                    < Button
                        className={classes.submit}
                        variant="contained"
                        type="submit"
                        onClick={() => { handleLogout(); }}
                    >
                        {translations['logout'] || 'Logout'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(UserIdleModal));




